import { CommonEnums } from '../../common.enums';

export class ParamObj {
    objectName: string;
    obj_Id: number;
    param_Id: number;
    text: string;
    name: string;
    paramType_Cd: string;
    paramDTyp_Id: number;
    paramPrec: number;
    paramScale: number;
    paramDesc: string
    paramDTyp_Name: string;
    icon: string

    constructor() {
        this.objectName = CommonEnums.defaults.STRING_EMPTY;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.param_Id = CommonEnums.defaults.LONG_VAL;
        this.text = CommonEnums.defaults.STRING_EMPTY;
        this.name = CommonEnums.defaults.STRING_EMPTY;
        this.paramType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.paramDTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.paramPrec = CommonEnums.defaults.LONG_VAL;
        this.paramScale = CommonEnums.defaults.LONG_VAL;
        this.paramDesc = CommonEnums.defaults.STRING_EMPTY;
        this.paramDTyp_Name = CommonEnums.defaults.STRING_EMPTY;
        this.icon = CommonEnums.defaults.STRING_EMPTY;
    }
}